var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_6814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9882 46.4535L46.0601 24.8118C46.0209 24.5958 45.8869 24.4087 45.6949 24.3019L35.808 18.8029C35.6797 18.7314 35.5358 18.703 35.3945 18.7139L37.1933 41.9179L37.133 41.9448L48.9655 47.2532C49.0617 47.2962 49.1641 47.3175 49.2659 47.3175C49.4272 47.3175 49.5869 47.2645 49.7183 47.1617C49.9329 46.9941 50.0367 46.7214 49.9882 46.4535Z",
    fill: "#44C868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 24.0602L14.888 18.7935C14.7668 18.7303 14.6324 18.7045 14.5001 18.7134C14.5352 18.7112 14.5704 18.7114 14.6054 18.7142L12.8066 41.9181L24.6993 47.2535C24.7953 47.2964 24.8978 47.3178 24.9998 47.3178V24.0602Z",
    fill: "#44C868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6055 18.7142C14.4642 18.7032 14.3203 18.7317 14.192 18.8031L4.30498 24.3021C4.11298 24.4088 3.979 24.5958 3.93984 24.812L0.0118045 46.4537C-0.0368284 46.7215 0.067078 46.9941 0.281629 47.1619C0.413172 47.2647 0.572841 47.3178 0.733974 47.3178C0.835829 47.3178 0.938271 47.2966 1.03446 47.2534L12.8025 41.974L14.6055 18.7142Z",
    fill: "#4CE166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3945 18.7136C35.2972 18.7211 35.201 18.747 35.1118 18.7935L25 24.0601V47.3178H25.0001C25.1021 47.3178 25.2047 47.2965 25.3006 47.2534L37.1933 41.9181L35.3945 18.7136Z",
    fill: "#4CE166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74717 31.3707L1.94922 35.7671L13.7651 29.5263L14.0394 25.9873L14.0849 25.4004L2.74717 31.3707Z",
    fill: "#FFDB56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8736 28.1536L13.7673 29.5258L1.95146 35.7667L0.0118045 46.4535C-0.0368284 46.7213 0.067078 46.9939 0.281629 47.1617C0.413172 47.2645 0.572841 47.3176 0.733974 47.3176C0.835829 47.3176 0.938271 47.2964 1.03446 47.2532L12.8025 41.9738L13.8736 28.1536Z",
    fill: "#A8EEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0013 26.9607L14.0854 25.3999L13.7656 29.5258L24.9984 46.5843V40.3814L18.2955 29.8269L25.0013 30.6289V26.9607Z",
    fill: "#FFBB24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9157 23.869L40.1662 21.2273L35.6699 22.2779L35.7262 23.0041L35.9482 25.8687L44.9157 23.869Z",
    fill: "#FFBB24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3489 31.013L35.9231 25.5199L35.6718 22.2778L25.0039 26.9607V30.6288L31.9723 27.5985L36.3489 31.013Z",
    fill: "#FFDB56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9903 46.4538L49.0036 41.0177L35.9512 25.8691L36.35 31.0135L49.7358 47.1484C49.9393 46.9797 50.0376 46.7149 49.9903 46.4538Z",
    fill: "#FFBB24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0469 2.68237C19.3864 2.68237 14.7812 7.28375 14.7812 12.9396C14.7812 16.4383 16.4423 20.1945 19.7184 24.1039C22.1245 26.9753 24.498 28.8221 24.5979 28.8993C24.7301 29.0016 24.8885 29.0526 25.047 29.0526C25.2054 29.0526 25.3639 29.0016 25.4961 28.8993C25.5959 28.8221 27.9695 26.9753 30.3756 24.1039C33.6517 20.1945 35.3127 16.4384 35.3127 12.9396C35.3125 7.28375 30.7074 2.68237 25.0469 2.68237ZM28.8487 12.9395C28.8487 15.0374 27.1465 16.7382 25.0469 16.7382C22.9473 16.7382 21.2451 15.0375 21.2451 12.9395C21.2451 10.8416 22.9473 9.14088 25.0469 9.14088C27.1465 9.14088 28.8487 10.8417 28.8487 12.9395Z",
    fill: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0487 2.68237C24.6001 2.68237 24.1582 2.71147 23.7246 2.76753C28.762 3.4186 32.6662 7.73199 32.6662 12.9396C32.6662 16.4383 31.0052 20.1945 27.7291 24.1039C26.1817 25.9504 24.649 27.3722 23.7247 28.1731C24.2378 28.6177 24.5642 28.8718 24.5997 28.8993C24.7319 29.0016 24.8903 29.0526 25.0488 29.0526C25.2072 29.0526 25.3657 29.0016 25.498 28.8993C25.5978 28.8221 27.9713 26.9753 30.3775 24.1039C33.6535 20.1945 35.3146 16.4384 35.3146 12.9396C35.3144 7.28375 30.7092 2.68237 25.0487 2.68237Z",
    fill: "#E7343F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3006 47.2534L29.723 45.2694L25 40.3816V47.3177H25.0001C25.1021 47.3177 25.2046 47.2965 25.3006 47.2534Z",
    fill: "#FFDB56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0582 24.8117C46.0191 24.5957 45.8851 24.4085 45.6931 24.3018L44.9148 23.8689L35.9473 25.8686L48.9996 41.0172L46.0582 24.8117Z",
    fill: "#1EA4E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 47.3174C25 47.3174 25 47.3174 24.9999 47.3174V46.5842L13.7673 29.5256L12.8066 41.9177L24.6993 47.2531C24.7953 47.2962 24.8978 47.3174 24.9999 47.3174Z",
    fill: "#1EA4E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_6814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact11);
export default __webpack_public_path__ + "static/media/contact_1_1.5ae07c1f38c629bf9805e9f77227af8b.svg";
export { ForwardRef as ReactComponent };